import { CopyButton as MantineCopyButton } from "@mantine/core";
import type { IProps } from "./copy-button.types";

const CopyButton = (props: IProps) => {
    return <MantineCopyButton {...props} />;
};

export { CopyButton };
